import { DecisionWithId } from '@livv/models';
import { getDecisionLink } from '@livv/utils/helpers';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import ClickableEntry from '@components/Timeline/ClickableEntry';
import { TimelinePositioningProps } from '@components/Timeline/types';
import { useFreemiumDialog } from '@utils/context/freemiumDialog';
import { formatDateFromUnixTime } from '@utils/date';

export const MAX_TITLE_LENGTH = 40;
export const TRUNCATE_SUFFIX = '…';

interface SameCaseProps extends TimelinePositioningProps {
    dataTestId?: string;
    decision: DecisionWithId;
    isCurrentDecision: boolean;
}

const SameCase: FC<SameCaseProps> = ({
    dataTestId,
    decision,
    isCurrentDecision,
    ...timelinePositioningProps
}) => {
    const { lang } = useTranslation();
    const { openFreemiumDialog } = useFreemiumDialog();

    const { id, number, performedAt, title } = decision;
    const performedAtDate = formatDateFromUnixTime(performedAt.seconds, lang);
    let titleWithoutDate = `${title.split(',')[0]} ${number.length > 0 ? ` n° ${number[0]}` : ''}`;
    if (titleWithoutDate.length > MAX_TITLE_LENGTH)
        titleWithoutDate = `${titleWithoutDate.slice(0, MAX_TITLE_LENGTH)}${TRUNCATE_SUFFIX}`;

    return (
        // TODO - VOG-1821: Make ClickableEntry work with direct links rather than redirection callback
        <ClickableEntry
            content={performedAtDate}
            dataTestId={dataTestId}
            href={getDecisionLink(id)}
            isActive={isCurrentDecision}
            onClick={openFreemiumDialog}
            title={titleWithoutDate}
            {...timelinePositioningProps}
        />
    );
};

export default SameCase;
